import { SHCheckboxButton } from "@components/design-systems/sh-checkbox-button";
import { ModelScreenerFilterDTO } from "@models/model-screener/entities/modelScreenerFilter";
import { tooltipClasses } from "@mui/material";
import { useState } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { useMount } from "react-use";
import { EditMSFilterPath } from "../../utils";

interface MSFilterCheckBoxButtonProps {
  label: string | JSX.Element;
  itemPath: EditMSFilterPath;
  disabled?: boolean;
  tooltipTitle?: string;
  defaultValue?: boolean;
}

export const MSFilterCheckBoxButton = ({
  label,
  itemPath,
  disabled,
  tooltipTitle,
  defaultValue = true,
}: MSFilterCheckBoxButtonProps) => {
  const { control, getValues } = useFormContext<ModelScreenerFilterDTO>();

  const [isChecked, setIsChecked] = useState<boolean>(defaultValue);

  useMount(() => {
    const formValue = getValues(itemPath);
    setIsChecked(formValue ? Boolean(formValue) : false);
  });

  return (
    <Controller
      key={`${itemPath}-${isChecked}`}
      control={control}
      name={itemPath}
      render={({ field: { ref, ...other } }) => {
        return (
          <SHCheckboxButton
            sx={{
              gap: 0.5,
            }}
            sxTooltipPopper={{
              [`&.${tooltipClasses.popper}[data-popper-placement*="top"] .${tooltipClasses.tooltip}`]:
                {
                  marginBottom: "5px",
                },
              width: "210px",
            }}
            label={label}
            value={isChecked}
            disabled={disabled}
            tooltipTitle={tooltipTitle}
            onClick={(value) => {
              setIsChecked(!isChecked);
              other.onChange(value);
            }}
          />
        );
      }}
    />
  );
};
